
import { defineComponent } from 'vue'
import ModalBase from '@/views/modal/ModalBase.vue'
import { object } from 'yup'
import { myValidationSchemaObj } from '@/views/validation'
import { useForm } from 'vee-validate'

interface InputForm {
  mailAddress: string;
}

const validationSchema = object({
  mailAddress: myValidationSchemaObj.requiredEmail
})

export default defineComponent({
  components: {
    ModalBase
  },
  emits: {
    dismiss: () => true,
    add: (mailAddress: string) => true
  },
  setup (props, { emit }) {
    const { errors, values, meta, validate } = useForm<InputForm>({
      validationSchema: validationSchema,
      validateOnMount: false
    })

    const dismiss = () => {
      emit('dismiss')
    }

    const add = () => {
      emit('add', values.mailAddress)
      values.mailAddress = ''
    }

    return {
      errors,
      values,
      meta,
      validate,
      dismiss,
      add
    }
  }
})
